import { SEARCH_INPUT_NUMBER_VALIDATION, SEARCH_INPUT_ALPHA_NUMERIC_VALIDATION } from "../../../../Reports/RecordsLookup/constants";
import shipmentGridConfig from '../Grid/ShipmentsGridConfig';
import customerGridConfig from '../Grid/CustomerGridConfig';
import shipperGridConfig from '../Grid/ShipperGridConfig';

export const defaultTabConfig  = [
  {
    gridName: 'Shipments',
    name: 'Pro Number',
    postApiCode: 'proId',
    getApiCode: 'proId',
    dataListKey: 'proOnHoldData',
    gridKey :"proId",
    inputProps : SEARCH_INPUT_NUMBER_VALIDATION,
    inputLabel: 'Pro Number',
    apiRequest: 'GetIBplanningPro',
    flag: 'shipment',
    gridConfig: shipmentGridConfig
  },
  {
    gridName: 'Customers',
    name: 'Customer',
    postApiCode: 'customerCode',
    getApiCode: 'code',
    dataListKey: 'customerOnHoldData',
    gridKey :"customerId",
    inputProps : SEARCH_INPUT_ALPHA_NUMERIC_VALIDATION,
    inputLabel: 'Customer Code',
    apiRequest: "SearchHoldData",
    flag: 'customer',
    gridConfig: customerGridConfig
  },
  {
    gridName: 'Shippers',
    name: 'Shipper',
    postApiCode: 'shipperCode',
    getApiCode: 'code',
    dataListKey: 'shipperOnHoldData',
    gridKey :"rmaxShipperCode",
    inputProps : SEARCH_INPUT_ALPHA_NUMERIC_VALIDATION,
    inputLabel: 'Shipper Code',
    apiRequest: "SearchHoldData",
    flag: 'shipper',
    gridConfig: shipperGridConfig
  }
];

export const excludedProStatus = ['Deleted', 'Delivered', 'OutForDelivery'];
